import { z } from "zod";

const EnvSchema = z.object({
  VITE_API_URL: z.string().url("VITE_API_URL must be a valid URL"),
  VITE_ZERO_CACHE_URL: z.string().url("VITE_ZERO_CACHE_URL must be a valid URL"),
  VITE_WEB_APP_URL: z.string().url("VITE_WEB_APP_URL must be a valid URL"),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SENTRY_TRACES_SAMPLE_RATE: z.string().optional(),
  VITE_SENTRY_REPLAYS_SAMPLE_RATE: z.string().optional(),
  VITE_GIT_COMMIT_SHA: z.string().optional(),
});

function formatError(error: z.ZodError): string {
  return error.errors.map((e) => `  ❌ ${e.path.join(".")}: ${e.message}`).join("\n");
}

const result = EnvSchema.safeParse(import.meta.env);

if (!result.success) {
  const message = `❌ Invalid environment variables:\n${formatError(result.error)}`;
  console.error(message);
  throw new Error(message);
}

/** Validated Vite env contract for web runtime configuration (throws on invalid startup env). */
export const Env = result.data;
